import React, { Component, ErrorInfo, ReactNode } from 'react';
import { triggerAppError } from '../Redirection';

interface Props {
  children?: ReactNode;
}

interface State {
  hasError: boolean;
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
  };

  public static getDerivedStateFromError(_: Error): State {
    return { hasError: true };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    //logging this to console for now, but in future, should log this somewhere more permanent
    console.log('Uncaught Error: ', error, errorInfo);
    triggerAppError(true);
  }

  public render() {
    if (this.state.hasError) {
      return <div data-test-id="error-boundary">{this.props.children}</div>;
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
